import React, { ReactNode, useReducer } from 'react';
import {
    triggerEventContext,
    triggerEventDispatchContext,
} from './triggerEventContext';
import { triggerEventContextReducer } from './triggerEventContextReducer';

type TriggerEventProviderProps = {
    children: ReactNode;
};

export const TriggerEventProvider = ({
    children,
}: TriggerEventProviderProps) => {
    const [state, dispatch] = useReducer(triggerEventContextReducer, {
        events: [],
    });

    return (
        <triggerEventContext.Provider value={state}>
            <triggerEventDispatchContext.Provider value={dispatch}>
                {children}
            </triggerEventDispatchContext.Provider>
        </triggerEventContext.Provider>
    );
};
